// extracted by mini-css-extract-plugin
export default {"textFooter":"styles_textFooter__Hb5y9","checkContainer":"styles_checkContainer__R0NZP","textCheckbox":"styles_textCheckbox__uadNw","title":"styles_title__zGLUR"};